<template>
  <div class="app flex-row align-items-center background-image">
    <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    />
    <div class="container">
      <!-- Row for centered image -->
      <div class="row justify-content-center">
        <div class="col-12 text-center" style="padding-bottom: 50px;">
          <img src="favicon.png" class="centered-image" alt="Logo Inpar">
        </div>
      </div>
      <!-- Login form container -->
      <div class="row justify-content-center mt-4">
        <div class="col-md-4">
          <div class="card-group mb-0">
            <div class="card p-4">
              <div class="card-body">
                <form v-on:submit="doLogin" action="#">
                  <h3>{{ appName }}</h3>
                  <p class="text-muted">Bem-vindo ao {{appName}}, para aceder à sua conta utilize o formulário abaixo.</p>
                  <b-form-group>
                    <b-input-group>
                      <b-input-group-text slot="prepend"><i class="fa fa-user"></i></b-input-group-text>
                      <b-form-input name="username" placeholder="Nome de utilizador" v-model="username" />
                    </b-input-group>
                  </b-form-group>
                  <b-form-group>
                    <b-input-group>
                      <b-input-group-text slot="prepend"><i class="fa fa-key"></i></b-input-group-text>
                      <b-form-input :type="showPassword ? 'text' : 'password'" placeholder="Palavra-passe" v-model="password" />
                      <i
                        :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"
                        @click="togglePasswordVisibility"
                        style="
                          position: absolute;
                          right: 10px;
                          top: 50%;
                          transform: translateY(-50%);
                          cursor: pointer;
                        "
                      ></i>
                    </b-input-group>
                  </b-form-group>
                  <div class="row">
                    <div class="col-6">
                      <router-link :to="{ name: 'SendRecovery' }">Esqueceu-se da palavra-passe?</router-link>
                    </div>
                    <div class="col-12 text-center">
                      <button :disabled="working" type="submit" class="btn btn-primary btn-block">Login</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.background-image {
  background-color: #fce9d7;
  background-size: cover; /* Cobre toda a área */
  background-position: center center; /* Centraliza a imagem */
  background-repeat: no-repeat; /* Não repete a imagem */
  height: 100vh; /* Faz a div ocupar a altura total da tela */
}
.text-right {
    text-align: center !important;
}
.btn-block {
  width: 100%; /* Garante que o botão ocupe 100% da largura */
}
.btn-primary {
    color: #fff;
    background-color: #ff5a00;
    border-color: #ff5a00;
}
.btn-primary:hover {
    color: #fff;
    background-color: #cd4800;
    border-color: #cd4800;
}
.btn-primary:disabled {
    color: #fff;
    background-color: #cd4800;
    border-color: #cd4800;
}
.centered-image {
  max-width: 125px;
  height: auto;
}
</style>
<script>
import SendRecovery from '@/views/pages/Send_recovery.vue';

export default {
  
  name: 'Login',
  data() {
    return {
      appName: 'Inpar',
      working: false,
      username: '',
      password: '',
      showPassword: false,
    }
  },
  beforeRouteEnter(to, from, next) {
    const viewport = document.querySelector("meta[name=viewport]");
    // Bloqueia o zoom na página de login
    viewport.setAttribute("content", "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no");
    next();
  },
  beforeDestroy() {
    const viewport = document.querySelector("meta[name=viewport]");
    // Restaura o comportamento normal de zoom
    viewport.setAttribute("content", "width=device-width, initial-scale=1.0, user-scalable=yes");
  },
  
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    toggleConfirmationPasswordVisibility(){
      this.showConfirmationPassword = !this.showConfirmationPassword;
    },
    selectAlternativePayment() {
      this.paymentMethod = this.alternativePaymentMethodValue;
    },

    
    onLogin() {
        
         // 
      this.$router.push('/dashboard').then(() => {
        window.location.reload();
        // Resetar zoom após redirecionamento para o dashboard
        document.body.style.zoom = '1';
      });
    },
    doLogin(event) {
      this.working = true
      event.preventDefault()
      var redirect = this.$auth.redirect()
      var redirectTo = {name: 'dashboard'}
      if (redirect) {
        redirectTo = redirect.from
      }
      this.$auth.login({
        data: {
          username: this.username,
          password: this.password
        },
        redirect: redirectTo,
        success: function(response) {
          this.$bvToast.toast(`Login efetuado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
        },
        error: function(response) {
          this.working = false
          this.$bvToast.toast(`Nome de utilizador ou palavra-passe incorrectos`, { autoHideDelay: 5000, variant: 'danger', solid: true })
        }
      })
      
    }
    
  },
  created() {
    if (typeof Window.appConfig !== 'undefined' && Window.appConfig.name) {
      this.appName = Window.appConfig.name
    }
  }
}
</script>
